import colors from 'constants/colors';

export const DEFAULT_COLORS = {
  header_bg_color: colors.oathBlue,
  primary_color: colors.inkBlue,
  secondary_color: colors.oathBlue,
  tertiary_color: colors.white,
  edge_color: colors.inkBlue,
  cta_color: colors.oathBlue,
};
